import {Component, Input, OnInit, ViewEncapsulation, ElementRef, ViewChild, Output, AfterViewInit} from '@angular/core';
import { EventEmitter } from '@angular/forms/src/facade/async';
import {EventBusCardService} from '../../../services/event-bus-card.service';
declare var jQuery: any;

@Component({
  selector: 'app-t2-card',
  templateUrl: './t2-card.component.html',
  styleUrls: ['./t2-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class T2CardComponent implements OnInit, AfterViewInit {

  @Input() title: string; // Titulo de la cabecera
  @Input() draggable: boolean; // Si es arrastable
  @Input() resizable: boolean; // Si es redimencionable
  @Input() modal: boolean; // Si es typo modal
  @Input() pop: boolean; // Si es typo pop
  @Input() popElementRef: ElementRef;
  @Input() btnClose = true;
  @Input() emitterBus = false;
  @Input() btnMinimize = false;
  @Input() minimizeNotDisplay: false;
  @Input() header = true;
  @Input() position = 'left';
  @Input() openRef: Element;
  @Input() top: string;
  @Input() height: string;
  @Input() backdropClose = true;
  @Output() EmitterAction: EventEmitter < any > = new EventEmitter < any > ();
  @ViewChild('draggable') el: ElementRef; // Referencial al elemento
  isOpen = false;
  isMinimized = false;
  progress = false;
  windowWidth: number;

  constructor(private card: ElementRef, private eventBus: EventBusCardService, private thatElement: ElementRef) {
    this.title = this.title ? this.title : 'Card';
  }

  /**
   * @Description:
   */
  ngOnInit() {}

  /**
   * @Description:
   */
  ngAfterViewInit() {
    if (this.draggable) {
      jQuery(this.el.nativeElement)
        .draggable({
          handle: '.t2-card-main-header',
          containment: this.modal || this.pop ? 'body' : '#layout-main-content'
        });
    }
    if (this.resizable) {
      jQuery(this.el.nativeElement)
        .resizable();
    }
    this.windowWidth = jQuery(window).width();
  }

  /**
   * @name toggleOpen
   * @desc Abrir y/o cerrar la modal
   */
  toggleOpen() {
    // this.isOpen = !this.isOpen;
    return this.isOpen ? this.close() : this.open();
  }

  position_x() {
    let elem = jQuery(this.openRef).offset().left;
    elem =  parseInt(elem, 10);
    const dom = window.innerWidth - 60;
    const clientWidth = jQuery('.card-pop', this.card.nativeElement).width() - 60;
    if ((dom - elem) > clientWidth) {
      return elem;
    } else if (clientWidth < elem) {
      return `${elem - clientWidth - 60}`;
    } else {
      return (dom / 2) -  clientWidth / 2;
    }
  };

  position_y() {
    let elem = jQuery(this.openRef).offset().top;
    elem =  parseInt(elem, 10);
    const dom = window.innerHeight - 50;
    const client = jQuery('.card-pop', this.card.nativeElement).height() - 50;
    if ((dom - elem) > client) {
      return elem + 50;
    } else if (client < elem) {
      return `${elem - client - 50}`;
    } else {
      return (dom / 2) -  client / 2;
    }
  };

  /**
   * @name open
   * @desc Abrir la modal
   * @return Object <EventEmitter>
   */
  open(event ?, config?: { centerModal?: boolean, top?: number }): boolean {
    const self = this;
    this.isOpen = true;
    if (!this.modal && !this.pop) {
      this.el.nativeElement.style.display = 'block';
      this.emitter();
    } else if (this.modal) {
      this.el.nativeElement.style.top = '-200vh';
      this.el.nativeElement.style.position = 'fixed';
      setTimeout(() => {
        this.el.nativeElement.style.top = this.top ? this.top : '80px';
        this.el.nativeElement.style.position = 'fixed';
        const w_ele = this.el.nativeElement.clientWidth;
        const w_window = window.innerWidth;
        const left = w_ele < w_window ? (w_window - w_ele) / 2 : 0;
        this.el.nativeElement.style.left = `${left}px`;
        // this.el.nativeElement.style.transform = `translateX(-50%)`;


        jQuery(this.thatElement.nativeElement).attrchange({
          trackValues: true, // set to true so that the event object is updated with old & new values
          callback: (attrchange) => {
            const el = attrchange.target.offsetWidth;
            const _left = (window.innerWidth - attrchange.target.offsetWidth) / 2;
            self.el.nativeElement.style.left = `${_left}px`;
          }
      });
        this.emitter();
      }, 100);
    } else {
      this.el.nativeElement.style.position = 'fixed';
      if (!this.openRef) {
        this.el.nativeElement.style.top = event.y + 'px';
        this.el.nativeElement.style.left = event.x + 'px';
        if (config && config.centerModal) {
          this.modalCenter(config.top);
        }
      } else {
        this.el.nativeElement.style.left = this.position_x() + 'px';
        this.el.nativeElement.style.top = this.position_y() + 'px';
      }

      // this.el.nativeElement.style.opacity = '0';
      this.emitter();

    }
    return true;
  }

  modalCenter(top = 50): void {
    const widthMiddle = (this.windowWidth / 2);
    const calculatedWidth = (widthMiddle / 2);
    jQuery(this.el.nativeElement).css('top', top, 'px');
    jQuery(this.el.nativeElement).css('left', calculatedWidth, 'px');
  }

  /**
   * @name close
   * @desc Cerrar la modal
   * @return Object <EventEmitter>
   */
  close() {
    this.isOpen = false;
    this.isMinimized = false;
    if (!this.modal && !this.pop) {
      this.el.nativeElement.style.display = 'none';
    }
    if (this.emitterBus) {
      this.eventBus.notificationReceived.next(event);
    }
    return this.emitter();
  }

  /**
   * @name minimize
   * @description minimizar la card
   */
  minimize() {
    this.isMinimized = true;
    return this.emitter();
  }

  /**
   * @name maximize
   * @description Restaurar la card
   */
  maximize() {
    this.isMinimized = false;
    return this.emitter();
  }

  /**
   * @name emitter
   * @description Emitir estado de la card
   */
  emitter() {
    return this.EmitterAction.emit({
      isOpen: this.isOpen,
      isMinimized: this.isMinimized
    });
  }

  /**
   * @name viewProgressBar
   * @description Mostrar o no barra de progreso
   * @param event
   */
  viewProgressBar(event: boolean) {
    this.progress = event;
  }

  backdropCloseEvent(): void {
    if (this.backdropClose) {
     this.close();
    } else {
      this.emitter();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-card/t2-card.component.ts